class Position {
  constructor(element, container = window, deductions = 0) {
    this.element = element;
    this.container = container;
    this.deductions = deductions;
    this.update();
  }
  update() {
    this.offHeight = this.element.offsetHeight;
    this.offBottom = (this.element.offsetTop - this.element.offsetHeight);
    this.offTop = this.element.offsetTop;
    this.offsetFromBottom = this.containerHeight - this.offHeight;
  }
  updateWith(offHeight, offBottom, offTop) {
    this.offHeight = offHeight;
    this.offBottom = offBottom;
    this.offTop = offTop;
  }
  updateWithOther(positionObj) {
    this.offHeight = positionObj.offHeight;
    this.offBottom = positionObj.offBottom;
    this.offTop = positionObj.offTop;
  }
  get containerHeight() {
    return ((this.container.innerHeight || this.container.offsetHeight) - this.deductions);
  }
  get scrollDisplacement() {
    return (this.container.pageYOffset || this.container.scrollTop);
  }
  get outOfView() {
    return ((this.offTop === 0 || this.offTop === undefined || !this.offTop) ? true : (this.outOfViewTop ||  this.outOfViewBottom));
  }
  get outOfViewTop() {
    return (((this.offTop + this.offHeight) - this.scrollDisplacement) >= this.containerHeight)
  }
  get outOfViewBottom() {
    return (this.scrollDisplacement >= this.offBottom);
  }

  print() {
    console.log("1. pageYOffset: " + this.scrollDisplacement);
    console.log("2. windowInnerHeight: " + this.containerHeight);
    console.log("3. offHeight: " + this.offHeight);
    console.log("4. offBottom: " + this.offBottom);
    console.log("5. offTop: " + this.offTop);
    console.log("6. outOfView: " + this.outOfView);
    console.log("7. outOfViewTop: " + this.outOfViewTop);
    console.log("8. outOfViewBottom: " + this.outOfViewBottom);

    console.log("------");
  }

}